import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import MainLayout from "../../src/components/layout/MainLayout";
import Breadcrumbs from "../../src/components/common/Breadcrumbs";
import BDIList from "../pages/Phase-04/BDI2/BDIList";

// Import Redux slice thunks
import {
  fetchBdiAssessments,
  deleteBdiAssessment,
  setCurrentBdiAssessment,
} from "../store/slices/bdiAssessmentsSlice";

const BDI = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const { bdiAssessments, isLoading, error } = useSelector(
    (state) => state.bdiAssessments
  );

  // Fetch all BDI assessments on mount
  useEffect(() => {
    dispatch(fetchBdiAssessments());
  }, [dispatch]);

  const handleAdd = () => {
    dispatch(setCurrentBdiAssessment(null));
    navigate("/phase04/bdi/add");
  };

  const handleEdit = (id) => {
    const assessment = bdiAssessments.find((a) => a.id === id);
    dispatch(setCurrentBdiAssessment(assessment));
    navigate(`/phase04/bdi/edit/${id}`);
  };

  const handleDelete = (id) => {
    dispatch(deleteBdiAssessment(id));
  };

  return (
    <MainLayout>
      <div className="container-xxl flex-grow-1 container-p-y">
        <Breadcrumbs />

        <div className="card">
          <div className="card-body p-0">
            <BDIList
              bdiAssessments={bdiAssessments}
              isLoading={isLoading}
              error={error}
              onAddBDI={handleAdd}
              onEditBDI={handleEdit}
              onDeleteBDI={handleDelete}
            />
          </div>
        </div>
      </div>
    </MainLayout>
  );
};

export default BDI;
